import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Product } from 'constants/products';

import './product-tabs.scss';

interface ProductTabsProps {
  products: Product[];
  // Absent in the documentation, which spans every product, so no tab claims
  // to be the one you are in.
  active?: Product;
}

/*
 * The products, laid out rather than hidden behind a dropdown.
 *
 * A bar suits this set where it did not suit the section links: products are
 * few and stable, three or maybe four ever, while sections are many and grow
 * per product. Small enough to show is small enough not to hide.
 *
 * Renders nothing at all for people who can reach a single product. A lone tab
 * is worse than no tab, and they should pay nothing for structure that exists
 * for managers who switch.
 */
export default function ProductTabs({ products, active }: ProductTabsProps) {
  if (products.length < 2) return null;

  return (
    <nav className="product-tabs" aria-label="Products">
      {products.map((product) => (
        <Link
          key={product.key}
          to={product.path}
          className={classNames('product-tabs__tab', {
            'product-tabs__tab--active': product.key === active?.key,
          })}
          aria-current={product.key === active?.key ? 'page' : undefined}
        >
          {product.name}
        </Link>
      ))}
    </nav>
  );
}
